import { Action } from '@ngrx/store';
import { ErrorResponse } from '~shared/models';
import { StoryblokApiResponse } from '~app/modules/storyblok/models/storyblok-api-response.model';

export enum StoryblokSeoActionTypes {
  LOAD_STORYBLOK_SEO_CONTENT = '[Storyblok] SeoContent Load',
  LOAD_STORYBLOK_SEO_CONTENT_SUCCESS = '[Storyblok] SeoContent Load Success',
  LOAD_STORYBLOK_SEO_CONTENT_FAILURE = '[Storyblok] SeoContent Load Failure',
}

export class LoadStoryblokSeoContent implements Action {
  readonly type = StoryblokSeoActionTypes.LOAD_STORYBLOK_SEO_CONTENT;

  constructor(public payload: { categorySlug: string }) {}
}

export class LoadStoryblokSeoContentSuccess implements Action {
  readonly type = StoryblokSeoActionTypes.LOAD_STORYBLOK_SEO_CONTENT_SUCCESS;

  constructor(public payload: { storyblokSEOContent: StoryblokApiResponse }) {}
}

export class LoadStoryblokSeoContentFailure implements Action {
  readonly type = StoryblokSeoActionTypes.LOAD_STORYBLOK_SEO_CONTENT_FAILURE;

  constructor(public payload: { error: ErrorResponse }) {}
}

export type StoryblokSeoActionsUnion =
  | LoadStoryblokSeoContent
  | LoadStoryblokSeoContentSuccess
  | LoadStoryblokSeoContentFailure;
